import { TYPES } from 'constants/config';
import setDefaultValue from 'utils/setDefaultValue';

const humanizedTypes = {
  [TYPES.LESSON]: 'Lesson',
  [TYPES.PATH]: 'Path',
  [TYPES.PLACEHOLDER]: 'Placeholder',
  [TYPES.WAITSTEP]: 'Wait Step',
};

const DEFAULT_TYPE = 'Content';

export function humanizeContentType(type, isCertification) {
  if (isCertification) {
    return TYPES.CERTIFICATION;
  }
  return setDefaultValue(humanizedTypes[type], DEFAULT_TYPE);
}
